// Best-effort email notification sent when a user shares a match, playlist
// or AI report with other users (opted into via the Share dialog's "Notify
// these users by email" checkbox). Posts to a Vercel serverless function
// (api/sendEmail.js) which actually talks to the configured email provider.
// This call is always optional/non-blocking — any failure (network error, or
// no provider configured yet server-side) is swallowed so a share action
// never fails or feels broken just because email sending isn't set up.
export async function sendShareNotification({
  to,
  itemType,
  itemTitle,
  sharedByEmail,
}) {
  const recipients = (Array.isArray(to) ? to : [to])
    .map((e) => String(e ?? "").trim())
    .filter(Boolean);
  if (recipients.length === 0) return;

  try {
    const res = await fetch("/api/sendEmail", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ to: recipients, itemType, itemTitle, sharedByEmail }),
    });
    if (!res.ok) {
      console.warn("sendShareNotification: server responded", res.status);
    }
  } catch (e) {
    console.warn("sendShareNotification failed (non-blocking):", e);
  }
}
